import React, { useState, useRef } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";

function Terrace() {
    const [showMore, setShowMore] = useState(false);
    const readMoreRef = useRef(null);

    const handleShowLess = () => {
        setShowMore(false);
        setTimeout(() => {
            if (readMoreRef.current) {
                readMoreRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };

    return (
      <div className="terrace-page homepage2-wrapper about-us-page">
        <Header />
        <style>
        {`
            .terrace-banner-responsive {
                background-image: url('/assets/img/food/new_banner.jpeg');
            }
            @media (max-width: 768px) {
                .terrace-banner-responsive {
                    /* REPLACE THIS WITH YOUR MOBILE BANNER IMAGE PATH */
                    background-image: url('/assets/img/food/ourstorym.jpeg');
                }
            }
        `}
        </style>
        <div
          className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed terrace-banner-responsive"
          data-overlay-dark="3"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "100%",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center caption mt-90">
                <h1>Terrace</h1>
              </div>
            </div>
          </div>
        </div>

        {/* Story Section */}
        <section className="our-story-section text-center" style={{ paddingTop: '80px' }}>
            <div className="container">
                <div className="story-text-container-full mb-5">
                    <p className="story-description">
                        Luxurious and full of character, with its intricate carvings, original artwork and glittering chandeliers, Chokhi Dhani’s delightful private dining room provides an intimate and unique space in which to dine. The elegant long polished table seats up to 14, whilst the room can also accommodate up to 30 guests for a cocktail and canapé reception.
                    </p>
                    <p className="story-description">
                        Please note that we operate strictly on Challenge 21. You may be asked to show proof of ID when ordering shisha/alcohol. Terrace is non-reservable, we operate on first come first served basis.
                    </p>
                </div>
            </div>
            
            <div className="container-fluid px-0 mb-5">
                <div className="story-slider-fullwidth">
                    <picture>
                        {/* REPLACE THIS WITH YOUR MOBILE CONTENT IMAGE PATH */}
                        <source media="(max-width: 768px)" srcSet="/assets/img/food/ourstorym.jpeg" />
                        {/* REPLACE THIS WITH YOUR DESKTOP CONTENT IMAGE PATH */}
                        <img src="/assets/img/food/our_story_img.jpg" alt="Chokhi Dhani London dining room" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                    </picture>
                </div>
            </div>

            <div className="container mb-5 mt-5">
                <div className="row align-items-center">
                    {/* Left Column: Shisha Menu and Content */}
                    <div className="col-md-6 text-start pe-md-5 mb-4 mb-md-0">
                        <h2 className="story-title" style={{ textAlign: "left", marginBottom: "15px" }}>Shisha Menu</h2>
                        <p className="story-description" style={{ textAlign: "justify" }}>
                            Experience our premium selection of shisha flavors carefully crafted to elevate your terrace dining experience. Relax and unwind as you enjoy the aromatic blends in a luxurious setting, complemented by our exquisite culinary offerings. Whether you prefer classic fruit flavors or unique house blends, our shisha menu has something for everyone.
                        </p>
                    </div>

                    {/* Right Column: Beautiful Opening Times Card */}
                    <div className="col-md-6 ps-md-5">
                        <div className="opening-times-card" style={{ border: '1px solid #c49a6c', padding: '30px', backgroundColor: 'rgba(0, 0, 0, 0.4)', borderRadius: '4px' }}>
                            <h4 style={{ fontFamily: "'Gilda Display', serif", color: "#e3b15a", marginBottom: '30px', textAlign: 'center', fontSize: '28px' }}>Terrace Opening Times</h4>
                            <div className="story-description" style={{ fontSize: '16px' }}>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Monday:</span>
                                        <span>Closed</span>
                                    </li>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Tuesday:</span>
                                        <span>17:30 to 22:00</span>
                                    </li>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Wednesday:</span>
                                        <span>17:30 to 22:00</span>
                                    </li>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Thursday:</span>
                                        <span>17:30 to 22:00</span>
                                    </li>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Friday:</span>
                                        <span>17:30 to 22:30</span>
                                    </li>
                                    <li style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Saturday:</span>
                                        <span style={{ textAlign: 'right' }}>12:30 to 15:00, 17:30 to 22:30</span>
                                    </li>
                                    <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#e3b15a', fontWeight: 'normal' }}>Sunday:</span>
                                        <span style={{ textAlign: 'right' }}>12:30 to 15:00, 17:30 to 21:30</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="container mb-2 text-center" ref={readMoreRef}>
                {!showMore ? (
                    <button onClick={() => setShowMore(true)} className="btn-story-readmore">Read More</button>
                ) : (
                    <div className="read-more-content" style={{ marginTop: '40px' }}>
                        <div className="story-text-container-full mb-5">
                            
                            <h2 className="story-title" style={{ marginTop: '50px' }}>Rooftop Restaurant in London- A Sky-High Culinary Experience</h2>
                            <div className="story-divider mx-auto">
                                <span>&#9830;</span>
                                <span>&#9830;</span>
                                <span>&#9830;</span>
                            </div>
                            <p className="story-description">
                                Imagine yourself in the open air, with breathtaking panoramic views of the London skyline and the gentle flow of the River Thames. This is the experience Chokhi Dhani London offers. Enjoy delicious flavours while taking in the magical atmosphere created by the sun setting and the city lights twinkling. This rooftop dining in London provides a more intimate setting that is ideal for everything from romantic dinners to private celebrations.
                            </p>
                        </div>
                        <button onClick={handleShowLess} className="btn-story-readmore mt-4">Show Less</button>
                    </div>
                )}
            </div>
        </section>
        <Footer />
      </div>
    );
}
export default Terrace;
